<!-- will render pages bases on stories or pages -->

@if (!!content) {
  <div [appStoryblok]="get_content(content._editable)" class="bg-white">
@for (section of content.sections; track $index) {
      @if(section.component ==='popup'){
        <app-cms-popup [popup]="section"></app-cms-popup>
      }@else if(section.component === 'bar'){
        <app-cms-bar [bar]="section"></app-cms-bar>
      }@else {
        <section [appStoryblok]="get_content(section._editable)" [ngClass]="{'mt-[-10px]' : $index === 0}" [id]="!section.anchor ? section._uid : section.anchor">
          <app-cms-section [section]="section" [index]="$index"></app-cms-section>
        </section>
      }
  }
  </div>
}
